import { render, staticRenderFns } from "./CloseUserMenuButton.vue?vue&type=template&id=60d23ba9&"
import script from "./CloseUserMenuButton.vue?vue&type=script&lang=js&"
export * from "./CloseUserMenuButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports